'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var COOKIE_NAMES = exports.COOKIE_NAMES = {
    JG_ANALYTICS_COOKIE_NAME: 'JGAnalytics',
    JG_ANALYTICS_AB: 'JGABID',
    KM: 'km_ai',
    KOALA_EmailIdentity: 'koala_ei',
    GGASPXAUTH_PROD_ID: '.GGASPXAUTH_ID',
    GGASPXAUTH_DEV_ID: '.GGASPXAUTH_DEV_ID',
    GGASPXAUTH_STAGING_ID: '.GGASPXAUTH_STAGING_ID',
    GGASPXAUTH_SANDBOX_ID: '.GGASPXAUTH_SANDBOX_ID'
};


// WEBPACK FOOTER //
// ../~/@jg/koala-front-end-analytics/lib/configs/cookieNames.js